import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var t = /*#__PURE__*/function () {
  function t() {
    _classCallCheck(this, t);

    this.operations = [], this.closed = !1;
  }

  _createClass(t, [{
    key: "close",
    value: function close() {
      this.closed = !0;
    }
  }, {
    key: "apply",
    value: function apply() {
      var _iterator = _createForOfIteratorHelper(this.operations),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t4 = _step.value;

          _t4.apply();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "undo",
    value: function undo() {
      for (var _t5 = this.operations.length - 1; _t5 >= 0; _t5--) {
        this.operations[_t5].undo();
      }
    }
  }, {
    key: "accumulate",
    value: function accumulate(_t3) {
      if (this.closed) return !1;
      var o = this.operations.length ? this.operations[this.operations.length - 1] : null;
      return o && o.accumulate(_t3) || (this.operations.push(_t3), _t3.apply()), !0;
    }
  }]);

  return t;
}();

export { t as UndoGroup };